var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrx = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#FF060A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7824 12.4227C22.9933 11.6436 21.9016 10.4539 21.0126 9.6102L20.96 9.57083C20.8724 9.49567 20.7737 9.43673 20.668 9.39646C18.5242 8.96896 8.54712 6.97493 8.35247 7.00024C8.29793 7.00841 8.2458 7.02955 8.19991 7.06211L8.14993 7.1043C8.08839 7.17112 8.04165 7.25185 8.01315 7.34055L8 7.37711V7.57679V7.60773C9.12318 10.9517 13.558 21.9063 14.4313 24.4769C14.4839 24.6513 14.5839 24.9831 14.7706 25H14.8127C14.9127 25 15.3388 24.3981 15.3388 24.3981C15.3388 24.3981 22.9564 14.5208 23.7271 13.4689C23.8269 13.3393 23.915 13.2 23.9902 13.0527C24.0094 12.9374 24.0003 12.8188 23.9639 12.7084C23.9275 12.598 23.865 12.4995 23.7824 12.4227ZM17.2932 13.573L20.5444 10.6902L22.4514 12.5689L17.2932 13.573ZM16.0306 13.3845L10.4331 8.47959L19.4896 10.2655L16.0306 13.3845ZM16.5356 14.6698L22.2646 13.6827L15.715 22.12L16.5356 14.6698ZM9.67293 8.96896L15.5624 14.3126L14.7101 22.1257L9.67293 8.96896Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrx);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TRX.621ca6a2a4a3c6923bc6e42f1994fbcb.svg";